import { type StaticImageData } from 'next/image'
import { data as dataDe } from './data/de'
import { data as dataAt } from './data/de-at'
import { data as dataCh } from './data/de-ch'
import { data as dataEs } from './data/es'
import {
  type Icon,
  type Menu,
  type MenuItem,
  type SubmenuId,
  type WithId,
} from './typings'

export function getDataByLocale(locale: string) {
  switch (locale) {
    case 'de-at':
      return dataAt
    case 'de-ch':
      return dataCh
    case 'es':
      return dataEs
    default:
      return dataDe
  }
}

// TODO delete all this and get menus from tanslations..
export function hasId(item: object): item is WithId {
  return typeof item === 'object' && 'id' in item
}

export function isMenu<I>(menu: Menu | MenuItem<I>): menu is Menu {
  return 'children' in menu
}

export function getMenuById<I>(
  id: SubmenuId,
  locale: string,
): (Menu<I> & WithId) | undefined {
  const data = getDataByLocale(locale)

  const found = data.main
    .filter((item) => isMenu(item) && hasId(item))
    .find((menu) => menu.id === id)

  return found
}

export function isStaticImageData(icon: Icon): icon is StaticImageData {
  return typeof icon !== 'string' && 'src' in icon
}
